













import Vue from 'vue'
import { Meta } from '@/tools/page'
import FacilitySearchView from '@/components/facility/FacilitySearchView.vue'

const PAGE_TITLE = 'フィットネスジム・スタジオ一覧'
const PAGE_META: Meta[] = [
  {
    name: 'description',
    content:
      'フィットネスジム・スタジオを多数掲載。利用料金は利用した分だけ！ジム初心者やしっかり体験したい方も安心の入会金無料・ビジターOKの都度利用型のジムネットワークサービス | 1チケットフィットネス GYYM',
  },
  {
    name: 'keywords',
    content: [
      'gyym',
      'GYYM',
      'ジム',
      'フィットネス',
      'スタジオ',
      'ジム 都度利用',
      'ジム 体験',
      'ジム 入会金無料',
      'ジム 初心者',
    ],
  },
]

export default Vue.extend({
  name: 'FacilityIndex',
  components: { FacilitySearchView },
  async created() {
    this.$setPageTitle(PAGE_TITLE)
    this.$setPageMeta(PAGE_META)
  },
})
